import { render, staticRenderFns } from "./IconAddTemplateQuestion.vue?vue&type=template&id=24be1170&"
var script = {}
import style0 from "./IconAddTemplateQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24be1170')) {
      api.createRecord('24be1170', component.options)
    } else {
      api.reload('24be1170', component.options)
    }
    module.hot.accept("./IconAddTemplateQuestion.vue?vue&type=template&id=24be1170&", function () {
      api.rerender('24be1170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconAddTemplateQuestion.vue"
export default component.exports